import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3.4 12a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0Zm7 0a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0Zm7 0a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0Z"
      clip-rule="evenodd"
    />
  </svg>
`;
